/**
 * Utilitário para carregar scripts externos (Google Analytics, Facebook Pixel, etc.)
 * baseado no consentimento do usuário.
 */

const GA_ID = process.env.REACT_APP_GA_ID || "G-2P98PYFBWB";

export const loadGoogleAnalytics = (measurementId = GA_ID) => {
  if (!measurementId) return;

  // 1. Configura a camada de dados (dataLayer)
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };

  // 2. Define o Modo de Consentimento Padrão (Importante para Google Signals e Realtime)
  window.gtag("consent", "default", {
    ad_storage: "denied",
    analytics_storage: "granted", // Já que esta função só é chamada após o consentimento
    ad_user_data: "denied",
    ad_personalization: "denied",
  });

  // Evita carregar o script mais de uma vez
  if (document.getElementById("google-analytics-script")) {
    console.log("ℹ️ Google Analytics já inicializado.");
    return;
  }

  // 3. Adiciona o script do gtag.js
  const script = document.createElement("script");
  script.id = "google-analytics-script";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  window.gtag("js", new Date());

  // Configuração inicial com visualização de página manual para SPAs
  window.gtag("config", measurementId, {
    send_page_view: false, // Desativa automático para não duplicar com o AnalyticsTracker
    anonymize_ip: true,
    cookie_flags: "SameSite=None;Secure",
  });

  console.log(`📊 Google Analytics (${measurementId}) ativado com sucesso!`);
};

/**
 * Registra uma visualização de página (Útil para SPAs)
 * @param {string} path - Caminho da página (ex: '/bots/123')
 */
export const trackPageView = (path) => {
  if (window.gtag) {
    window.gtag("event", "page_view", {
      page_path: path,
    });
  }
};

/**
 * Vincula o ID do usuário logado ao Google Analytics (User-ID)
 * @param {string} userId - ID do usuário (Discord ID)
 */
export const setAnalyticsUserId = (userId) => {
  if (window.gtag) {
    window.gtag("config", GA_ID, {
      user_id: userId,
    });
    console.log(`👤 User-ID definido no Analytics: ${userId}`);
  }
};

/**
 * Registra um evento personalizado no Google Analytics
 * @param {string} eventName - Nome do evento (ex: 'click_bot', 'vote_bot')
 * @param {object} params - Parâmetros extras (ex: { bot_name: 'AntiGravity' })
 */
export const trackEvent = (eventName, params = {}) => {
  // Log de debug para verificação
  console.log(`[GA Event] ${eventName}:`, params);

  if (window.gtag) {
    window.gtag("event", eventName, params);
  } else if (window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      ...params,
    });
  }
};

export const initializeMarketingScripts = () => {
  // Exemplo: Ativar Pixel do Facebook
  // console.log("📣 Scripts de Marketing ativados!");
};
